import { render, staticRenderFns } from "./ReceivingDetail.vue?vue&type=template&id=1bc425fe&"
import script from "./ReceivingDetail.vue?vue&type=script&lang=js&"
export * from "./ReceivingDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports